import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [
    CommonNgModule,
    IconComponent
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnInit {
  @Input() Theme:any;
  @Input() Label:any;
  @Input() IcoSvg:any;
  @Input() Loading_sk: any;
  constructor() { }

  ngOnInit() {
  }

}
